import React, { useState, ChangeEvent, useEffect } from "react";
import {
  addDomain,
  deleteDomain,
  deleteDomains,
  Domain,
  getAllDomains,
  getDomains,
} from "@redux/slices/domains";
import { useNavigate } from "react-router";
import { Button } from "@components/ui/button";
import { IoAdd } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";
import LoadingScreen from "@components/LoadingScreen";
import Table from "@components/Table";
import { Checkbox, IconButton } from "@mui/material";
import Iconify from "@components/iconify";
import ReactPaginate from "react-paginate";
import * as Select from "@radix-ui/react-select";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { BlacklistTableHead } from "@assets/mocks/tableData";
import { Download, Upload } from "lucide-react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { enqueueSnackbar } from "notistack";
import Papa from "papaparse";
import useAuth from "@hooks/useAuth";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import * as XLSX from "xlsx";
import axios from "axios";

interface TableData {
  id: string;
  domain_name: string;
  created_at: string;
  user_name: string;
}

const Blacklist: React.FC = () => {
  const [selected, setSelected] = useState<string[]>([]);
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [upload, setUpload] = useState(false);
  const [domains, setDomains] = useState<TableData[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  let filteredData: TableData[] = [];

  //
  // const [itemsPerPage, setItemsPerPage] = useState(10);  // Default to 10 items per page
  //     // Pagination current page
  // const totalItems = 100; // Example total items, should come from your data source
  // const pageCount = Math.ceil(totalItems / itemsPerPage); // Calculate total pages

  // const handlePageClick = (data: { selected: number }) => {
  //   setCurrentPage(data.selected);
  //   // Logic to load data for the selected page
  // };

  // const handleSelectChange = (value: string) => {
  //   setItemsPerPage(Number(value)); // Update items per page
  //   setCurrentPage(0); // Reset to first page
  // };
  //

  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  useEffect(() => {
    setLoading(true);
    getData();
  }, [upload, window.location.pathname]);

  const getData = async () => {
    const data =
      user?.role !== "admin"
        ? await getAllDomains(window.location.pathname.split("/")[2])
        : selectedUserId !== null
        ? await getAllDomains(selectedUserId)
        : window.location.pathname.split("/")[2] === "admin"
        ? await getDomains()
        : await getAllDomains(window.location.pathname.split("/")[2]);

    if (data) {
      const sortedData = data.sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateB - dateA;
      });

      setDomains(sortedData);
    } else {
      setDomains([]);
    }

    setLoading(false);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  // Apply search filter
  const searchFilteredData = domains.filter(
    (domain) =>
      domain.domain_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      domain.user_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const endOffset = itemOffset + itemsPerPage;

  filteredData = searchFilteredData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(searchFilteredData?.length / itemsPerPage);

  const handlePageClick = (event: { selected: number }) => {
    console.log("hey");
    const newOffset =
      (event.selected * itemsPerPage) % searchFilteredData?.length;
    setItemOffset(newOffset);
  };

  const handleSelectChange = (value: string) => {
    setItemsPerPage(Number(value)); // Update items per page
    console.log(itemsPerPage);
    setCurrentPage(3); // Reset to first page
  };
  const [currentPage, setCurrentPage] = useState(0);
  const handleSelectAllClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = domains?.map((n) => n.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleClick = (name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const downloadPDF = (domains: TableData[]) => {
    const doc = new jsPDF();
    doc.text("Domain List", 14, 20);

    const tableColumn = ["Domain Name", "Created At", "User Name"];
    const tableRows: any[] = [];

    domains.forEach((domain) => {
      const domainData = [
        domain.domain_name,
        domain.created_at.split("T")[0],
        domain.user_name,
      ];
      tableRows.push(domainData);
    });

    (doc as any).autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
    });

    doc.save("domain-list.pdf");
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("first");
    setUpload(true);
    setLoading(true);

    const file = event.target.files?.[0];

    if (!file) {
      enqueueSnackbar("No file selected", { variant: "warning" });
      setLoading(false);
      return;
    }

    const reader = new FileReader();

    console.log(domains);
    console.log("domain that are in already");

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      try {
        const domainNames: string[] = [];

        for (const [index, row] of jsonData.entries()) {
          if (index === 0) continue;
          const typedRow = row as string[];
          const domain_name = typedRow[0]?.toString();
          const user_name = user?.first_name + " " + user?.last_name;
          const user_id = user?.id;

          const isDomainPresent = domains.some(
            (domain) => domain.domain_name === domain_name
          );
          if (
            domain_name &&
            (domain_name.startsWith("www") ||
              domain_name.startsWith("http://") ||
              domain_name.startsWith("https://") ||
              domain_name.startsWith("https"))
          ) {
            enqueueSnackbar("Domain name cannot start with 'www', 'http://', or 'https://'", { variant: "error" });
            setLoading(false); // Turn off loading state
            return; // Exit the function to prevent further processing
          }
          if (
            domain_name &&
            !domain_name.startsWith("www") &&
            !domain_name.startsWith("http://") &&
            !domain_name.startsWith("https://") &&
            !domain_name.startsWith("https") &&
            !isDomainPresent
          ) {
            await addDomain(
              { domain_name, user_name, user_id },
              "Domain added successfully!"
            );
            domainNames.push(domain_name); // Add domain_name to the array
          }
        }

        try {
          const response = await axios.post(
            "https://aquisize-backend-zrj2.onrender.com/api/blacklist-domains",
            {
              domains: domainNames,
            }
          );

          console.log("Domain added successfully:", response.data);
        } catch (error) {
          console.error("Error adding domain:", error);
        } finally {
          setLoading(false); // Turn off loading state
        }

        await getData();

        enqueueSnackbar("Excel upload complete", { variant: "success" });
      } catch (error) {
        enqueueSnackbar("Error uploading Excel file", { variant: "error" });
      }

      setLoading(false);
    };

    reader.onerror = (error) => {
      enqueueSnackbar(`Error reading file: ${error}`, { variant: "error" });
      setLoading(false);
    };

    reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
  };

  const handleDownloadTemplate = () => {
    const data = [
      ["Sample Data"],
      ["sample1.com"],
      ["sample2.com"],
      ["sample3.com"],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const xlsxBlob = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const blob = new Blob([xlsxBlob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "domain-template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex items-center justify-end mt-7 ">
          <div className="md:mb-0 mb-4 me-4">
              <div className="relative">
                <input
                  className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                  id="search"
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <div className="absolute left-0 inset-y-0 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#71717A"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="sm:flex items-center">
              <div className="sm:mb-0 mb-4 flex items-center">
                <div className="me-2 md:w-52 w-full md:my-0 my-3">
                  <Select.Root
                    onValueChange={(value) => {
                      if (value === "LISTED_DOMAINS") {
                        console.log("Listed Domains clicked");
                        downloadPDF(domains);
                      } else if (value === "UPLOAD_TEMPLATE") {
                        console.log("Upload Template clicked");
                        handleDownloadTemplate();
                        // Add your template upload function here
                      }
                    }}
                  >
                    <SelectTrigger className="SelectTrigger bg-white border-none">
                      <span className="placeholder">Download</span>
                    </SelectTrigger>
                    <SelectContent className="SelectContent">
                      <SelectItem value="LISTED_DOMAINS">
                        Listed Domains
                      </SelectItem>
                      <SelectItem value="UPLOAD_TEMPLATE">
                        Download Template
                      </SelectItem>
                    </SelectContent>
                  </Select.Root>
                </div>
              </div>

              {user?.role !== "admin" && (
                <div className="rounded-md bg-white mx-3 p-4 py-2 shadow-sm ">
                  <label
                    htmlFor="upload"
                    className="flex flex-col items-center gap-2 cursor-pointer"
                  >
                    <span className="text-gray-600 font-medium text-sm flex items-center">
                      <Upload size={20} className="me-2" />
                      Upload
                    </span>
                  </label>
                  <input
                    id="upload"
                    type="file"
                    className="hidden"
                    accept=".xlsx"
                    onChange={handleFileUpload}
                  />
                </div>
              )}

              {user?.role !== "admin" && (
                <Button
                  className="bg-[#1CB5AF]"
                  onClick={() => navigate("/blacklist/addDomain")}
                >
                  <IoAdd size={20} className="me-2" />
                  Domain
                </Button>
              )}
            </div>
          </div>
          {selected.length > 0 && (
            <div className="bg-gray flex justify-between rounded-t-lg px-5 py-2 items-center mt-5 text-white">
              <p>{selected?.length} selected</p>
              <IconButton
                className="text-white"
                onClick={async () => {
                  setLoading(true);
                  await deleteDomains(selected);
                  getData();
                  setSelected([]);
                }}
              >
                <FiTrash2 color="white" />
              </IconButton>
            </div>
          )}
          <Table
            checkbox={user?.role !== "admin" && true}
            textIndex={3}
            tableHead={BlacklistTableHead}
            handleSelectAllClick={handleSelectAllClick}
          >
            {filteredData?.map((val, index) => (
              <tr
                key={index}
                className="text-sm text-gray text-center border-b last:border-0 border-[#EAECF0]"
              >
                {user?.role !== "admin" && (
                  <td>
                    <Checkbox
                      disableRipple
                      checked={selected.indexOf(val.id) !== -1}
                      onChange={() => handleClick(val.id)}
                      sx={{
                        color: "#08A696", // Unchecked color
                        "&.Mui-checked": {
                          color: "#08A696", // Checked color
                        },
                      }}
                    />
                  </td>
                )}
                <td className="p-5 text-left ">{val.domain_name}</td>
                <td className="p-5 text-left">
                  {val.created_at.split("T")[0]}
                </td>
                <td className="p-5 text-left text-lime-700 font-medium">
                  {val.user_name}
                </td>
                {user?.role !== "admin" && (
                  <td>
                    <IconButton
                      className="text-gray"
                      onClick={async () => {
                        setLoading(true);
                        console.log([val.domain_name]);
                        try {
                          const response = await axios.post(
                            "https://aquisize-backend-zrj2.onrender.com/api/delete-domains",
                            {
                              domains: [val.domain_name],
                            }
                          );
                          await deleteDomain(val?.id);

                          console.log(
                            "Domain deleted successfully:",
                            response.data
                          );
                        } catch (error) {
                          console.error("Error adding domain:", error);
                        } finally {
                          setLoading(false); // Turn off loading state
                        }
                        getData();
                      }}
                    >
                      <Iconify icon="eva:trash-2-outline" />
                    </IconButton>
                  </td>
                )}
              </tr>
            ))}
          </Table>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
            <div className="me-2 w-32 md:mb-0 mb-4">
              <Select.Root onValueChange={handleSelectChange}>
                <SelectTrigger className="SelectTrigger bg-white border-none">
                  <SelectValue placeholder={`${itemsPerPage} per Page`} />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="25">25 per page</SelectItem>
                  <SelectItem value="50">50 per page</SelectItem>
                  <SelectItem value="100">100 per page</SelectItem>
                  <SelectItem value="200">200 per page</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>

            {/* Pagination Component */}
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={itemsPerPage}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "← Previous" : "<"}
                renderOnZeroPageCount={() => null}
                activeClassName="bg-white"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blacklist;